<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-md-3.col-3.mb-1
        DateRangePicker(:value="dateRange" @update="getData")
      .form-group.col-md-1.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getStatement(true)"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      .col-md-10.col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-md-2.col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-md-12.col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th(width="10%" @click="sortOrder('working_date')")
                  span(:title="$t('ui.working_date')") {{ $t('ui.working_date') }}
                  .float-right
                    i(:class="changeSortKey('working_date')")
                th.text-right(width="11%")
                  span(:title="$t('ui.opening_balance')") {{ $t('ui.opening_balance') }}
                th.text-right(width="11%")
                  span(:title="$t('ui.earning')") {{ $t('ui.earning') }}
                th.text-right(width="11%")
                  span(:title="$t('ui.withdrawal_amount')") {{ $t("ui.withdrawal_amount") }}
                th.text-right(width="11%")
                  span(:title="$t('ui.adjustment_amount')") {{ $t("ui.adjustment_amount") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.closing_balance')") {{ $t("ui.closing_balance") }}
            tbody.clusterize-content
              tr(v-if="statementList.length == 0")
                td(colspan="6").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in statementList")
                td
                  span(:title="$moment(item.working_date).format('YYYY-MM-DD')") {{ $moment(item.working_date).format('YYYY-MM-DD') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.opening_balance)" :title="$n(item.opening_balance, 'currency')") {{ $n(item.opening_balance, 'currency') }}
                td.text-right
                  span.font-weight-bold(v-if="item.earning == 0" :class="$helpers.fontClassName(item.earning)" :title="$n(item.earning, 'currency')") {{ $n(item.earning, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.withdrawal_amount * -1)" :title="$n(item.withdrawal_amount > 0 ? item.withdrawal_amount * -1 : item.withdrawal_amount, 'currency')") {{ $n(item.withdrawal_amount > 0 ? item.withdrawal_amount * -1 : item.withdrawal_amount, 'currency') }}
                td.text-right
                  span.font-weight-bold
                    b-link(href="javascript:void(0);" @click="redirectToAdjustment(item)" :class="[item.adjustment_amount < 0 ? 'text-danger' : 'text-info']" :title="$n(item.adjustment_amount, 'currency')") {{ $n(item.adjustment_amount, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.closing_balance)" :title="$n(item.closing_balance, 'currency')") {{ $n(item.closing_balance, 'currency') }}
              tr(v-if="showTotal")
                td.text-right(colspan="2")
                  span {{ $t("ui.sub_total") }}
                  br
                  span {{ $t("ui.grand_total") }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalEarning)" :title="$n(subTotalEarning, 'currency')") {{ $n(subTotalEarning, 'currency') }}
                  br
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalEarning)" :title="$n(grandTotalEarning, 'currency')") {{ $n(grandTotalEarning, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="[subTotalWithdrawalAmount == 0 ? 'text-primary' : 'text-danger']" :title="$n(subTotalWithdrawalAmount > 0 ? subTotalWithdrawalAmount * -1 : subTotalWithdrawalAmount, 'currency')") {{ $n(subTotalWithdrawalAmount > 0 ? subTotalWithdrawalAmount * -1 : subTotalWithdrawalAmount, 'currency') }}
                  br
                  span.font-weight-bold(:class="[grandTotalWithdrawalAmount == 0 ? 'text-primary' : 'text-danger']" :title="$n(grandTotalWithdrawalAmount > 0 ? grandTotalWithdrawalAmount * -1 : grandTotalWithdrawalAmount, 'currency')") {{ $n(grandTotalWithdrawalAmount > 0 ? grandTotalWithdrawalAmount * -1 : grandTotalWithdrawalAmount, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalAdjustmentAmount)" :title="$n(subTotalAdjustmentAmount, 'currency')") {{ $n(subTotalAdjustmentAmount, 'currency') }}
                  br
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAdjustmentAmount)" :title="$n(grandTotalAdjustmentAmount, 'currency')") {{ $n(grandTotalAdjustmentAmount, 'currency') }}
                td
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker
  },
  data: () => ({
    loading: false,
    statementList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    subTotalEarning: 0,
    grandTotalEarning: 0,
    subTotalWithdrawalAmount: 0,
    grandTotalWithdrawalAmount: 0,
    subTotalAdjustmentAmount: 0,
    grandTotalAdjustmentAmount: 0,
    showTotal: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    sortKey: "working_date",
    sortType: "desc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    affiliateID() {
      return this.$store.getters.selectedAffiliateID
    }
  },
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
  },
  methods: {
    refresh() {
      this.getStatement(true);
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getStatement(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getStatement(true);
    },
    setDailyStatementAffParam() {
      // var json = {
      //   account_id: this.search.trim(),
      //   start_date: this.dateRange.startDate,
      //   end_date: this.dateRange.endDate
      // };

      // this.$store.dispatch("user/setDailyStatementAffParam", json);
    },
    redirectToAdjustment: function(item) {
      // var json = {
      //   account_id: this.search.trim(),
      //   start_date: item.working_date,
      //   end_date: item.working_date
      // };

      // this.$store.dispatch("user/setAdjustmentListAffParam", json);
      // this.$router.push("/affiliate/adjustmentListAffiliate");
    },
    getStatement: function(isSearch) {
      if (this.checkDateRange()) {

        // if (this.search.trim() == '') {
        //   this.clearTotal();
        //   this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.accountIdRequired"), "error");
        //   return;
        // }

        // this.setDailyStatementAffParam();

        let url = config.dailyStatementAffUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,          
          account_id: this.affiliateID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  if(response.data.ds.statement.length > 0) {
                    this.showTotal = true;
                    response.data.ds.statement.forEach(value => {
                      this.subTotalEarning = parseFloat(this.subTotalEarning) + parseFloat(value["earning"]);
                      this.subTotalWithdrawalAmount = parseFloat(this.subTotalWithdrawalAmount) + parseFloat(value["withdrawal_amount"]);
                      this.subTotalAdjustmentAmount = parseFloat(this.subTotalAdjustmentAmount) + parseFloat(value["adjustment_amount"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalEarning = response.data.ds.grand_total[0]["earning"];
                      this.grandTotalWithdrawalAmount = response.data.ds.grand_total[0]["withdrawal_amount"];
                      this.grandTotalAdjustmentAmount = response.data.ds.grand_total[0]["adjustment_amount"];
                    }

                    this.statementList = response.data.ds.statement;
                    this.totalRow = response.data.ds.statement.length > 0 ? this.statementList[0]["totalrows"] : 0
                  } else {
                    this.clearTotal()
                  }
                } else {
                  this.clearTotal()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotal();
        this.statementList = [];
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    clearTotal() {
      this.showTotal = false
      this.statementList = []
      this.totalRow = 0
      this.subTotalEarning = 0
      this.grandTotalEarning = 0
      this.subTotalWithdrawalAmount = 0
      this.grandTotalWithdrawalAmount = 0
      this.subTotalAdjustmentAmount = 0
      this.grandTotalAdjustmentAmount = 0
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getStatement(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getStatement();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>